import React from "react";

const Modal = ({ id, projects }) => {
  const selectedProject = projects.find((project) => project.id === id);
  const { name, img, technology, desc, live, gitClient, gitServer } =
    selectedProject;
  return (
    <>
      <input type="checkbox" id="modal" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box w-11/12 max-w-6xl relative">
          <label
            htmlFor="modal"
            className="myBtn btn-sm btn-circle absolute right-3 top-3"
          >
            ✕
          </label>
          <div className="lg:mt-2 md:mt-2 mt-8 grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-y-5">
            {/* carousel start */}
            <div>
              <div className="carousel w-full ">
                <div id="item1" className="carousel-item w-full">
                  <img src={img} className="w-full" alt="" />
                </div>
                <div id="item2" className="carousel-item w-full">
                  <img src={img} className="w-full" alt="" />
                </div>
                <div id="item3" className="carousel-item w-full">
                  <img src={img} className="w-full" alt="" />
                </div>
              </div>
              <div className="flex justify-center w-full lg:pt-2 md:pt-2 pt-4 gap-2">
                <a href="#item1" className="myBtn-outline btn-circle btn-xs">
                  1
                </a>
                <a href="#item2" className="myBtn-outline btn-circle btn-xs">
                  2
                </a>
                <a href="#item3" className="myBtn-outline btn-circle btn-xs">
                  3
                </a>
              </div>
            </div>
            <div className="lg:pt-3 lg:px-8">
              <div className="text-center">
                <h1 className="font-bold text-xl">{name}</h1>
                <p className="mt-1 mb-3 font-[500]">
                  <a
                    href={live}
                    className="text-[#2782f2] mr-2"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Live website
                  </a>
                  ||{" "}
                  <a
                    href={gitClient}
                    className="text-[#2782f2] mx-2"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Github-Client
                  </a>
                  {gitServer && (
                    <>
                      ||{" "}
                      <a
                        href={gitServer}
                        className="text-[#2782f2] ml-2"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Github-Server
                      </a>
                    </>
                  )}
                </p>
                <hr />
              </div>
              <p className="mt-3">{desc}</p>
              <p className="mt-2">
                <span className="mr-2">Technology:</span>
                {technology.map((i, index) => (
                  <span
                    key={index}
                    className="badge p-4 bg-gray-100 border-none text-neutral font-[500] mr-3 mt-2"
                  >
                    {i}
                  </span>
                ))}
              </p>
            </div>
          </div>
          <div className="modal-action"></div>
        </div>
      </div>
    </>
  );
};

export default Modal;
